export default "/_next/static/images/732594029e0fef757218931a61ffda00.jpg";